
const StartupFeatures = () => {
  const features = [
    {
      title: "5-Minute Campaign Builder",
      description: "From concept to live campaign in 5 minutes. Just answer a few questions about your product and target market, and AI handles the rest."
    },
    {
      title: "Quick Market Testing Tools",
      description: "Test new audiences, keywords, and messaging rapidly. Launch multiple campaign variants to see what resonates before scaling up."
    },
    {
      title: "Budget Optimization Engine",
      description: "AI automatically adjusts your limited budget to focus on the highest-performing ads and keywords, maximizing every dollar you spend."
    },
    {
      title: "Rapid Iteration Dashboard",
      description: "Make real-time changes to your campaigns as you learn. No waiting for agency approvals or complex platform navigation."
    }
  ];

  return (
    <div className="mb-16">
      <div className="text-center mb-10">
        <h2 className="text-3xl font-bold mb-4">Built for Speed and Testing</h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          Features that help you launch fast, test quickly, and make your budget work harder.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="flex gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-amber-500">
              <span className="text-2xl font-bold">{index + 1}</span>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StartupFeatures;
